module.exports = __webpack_public_path__ + "images/emoji/hear_no_evil.bd35485ff4360e7a201a.png";